import React from 'react';

export default function Compliance() {
  return (
    <div>
      <h1>Compliance</h1>
      <p className="empty">Documents (rate confirmations, BOLs, PODs, permits) attach per-load — pull them via /api/compliance/documents?loadId=... once you're viewing a specific load.</p>
    </div>
  );
}
